import {Injectable} from '@angular/core';
import {Platform} from "ionic-angular";

@Injectable()
export class PlatformService {

  constructor(
    private platform: Platform) {}

  public isMobile(): boolean {
    ['android',
      'cordova',
      'core',
      'ios',
      'ipad',
      'iphone',
      'mobile',
      'mobileweb',
      'phablet',
      'tablet',
      'windows'].forEach(p => console.log(p + ": " + this.platform.is(p)));
    const result = !this.platform.is('mobileweb') && (this.platform.is('ios') || this.platform.is('android'));
    console.log('isMobile: ' + result)
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/modules/core/services/platform-service/platform-service.ts